// extracted by mini-css-extract-plugin
export default {"reportFailureDialog":"a0I9j","submissionMessage":"tsmuN","download":"_FkEl","imageDiv":"MN9lH","imgDivBg":"dzVGf"};